module.exports = __webpack_public_path__ + "img/Group126.cc4e67d0.png";